import React from 'react';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

const TermsOfService = ({ onBack }) => {
    return (
        <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
            <nav className="fixed w-full bg-white/80 backdrop-blur-md z-50 border-b border-slate-200">
                <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                    <button
                        onClick={onBack}
                        className="flex items-center gap-2 text-slate-600 hover:text-blue-600 transition-colors font-medium"
                    >
                        <ArrowLeft size={20} />
                        Back to Home
                    </button>
                    <div className="flex items-center gap-2">
                        <ShieldCheck className="text-blue-600" size={24} />
                        <span className="font-bold text-xl tracking-tight text-slate-900">Terms of Service</span>
                    </div>
                </div>
            </nav>

            <main className="pt-32 pb-20 max-w-4xl mx-auto px-6">
                <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-200 prose prose-slate max-w-none">
                    <h1 className="text-3xl font-bold mb-8 text-slate-900">Terms of Service</h1>
                    <p className="text-slate-500 mb-8">Last Updated: December 2025</p>

                    <h2>1. Agreement to Terms</h2>
                    <p>
                        By accessing or using Resume Architect ("the Service"), you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
                    </p>

                    <h2>2. Description of Service</h2>
                    <p>
                        Resume Architect provides AI-powered resume building, analysis, and optimization tools. We reserve the right to modify, suspend, or discontinue the Service at any time without notice.
                    </p>

                    <h2>3. User Accounts</h2>
                    <p>
                        When you create an account with us, you must provide information that is accurate, complete, and current. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
                    </p>

                    <h2>4. Intellectual Property</h2>
                    <p>
                        The Service and its original content (excluding Content provided by you or other users), features, and functionality are and will remain the exclusive property of Resume Architect and its licensors.
                    </p>

                    <h2>5. User Content</h2>
                    <p>
                        You retain all rights to any resume data, personal information, or other content you submit to the Service. By submitting content, you grant us the right to process it for the purpose of providing the agreed services (e.g., formatting, AI analysis).
                    </p>

                    <h2>6. AI Usage</h2>
                    <p>
                        Our Service utilizes Artificial Intelligence. While we strive for accuracy, AI-generated content may contain errors or inaccuracies. You are responsible for reviewing and verifying all generated content before using it.
                    </p>

                    <h2>7. Limitation of Liability</h2>
                    <p>
                        In no event shall Resume Architect, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.
                    </p>

                    <h2>8. Governing Law</h2>
                    <p>
                        These Terms shall be governed and construed in accordance with the laws of the jurisdiction in which Resume Architect operates, without regard to its conflict of law provisions.
                    </p>

                    <h2>9. Contact Us</h2>
                    <p>
                        If you have any questions about these Terms, please contact us at <a href="mailto:resume.architect.pro.help@gmail.com" className="text-blue-600 hover:text-blue-800">resume.architect.pro.help@gmail.com</a>.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default TermsOfService;
